export default theme => ({
  dialogRoot: {
    [theme.breakpoints.up('sm')]: {
      width: 450,
    },
    [theme.breakpoints.down('sm')]: {
      margin: 5
    }
  },
  autoWidth: {
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
  },
  title: {
    whiteSpace: 'pre-line',
  },
  description: {
    padding: theme.spacing(0, 3),
  },
  closeBtn: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: theme.palette.textColor.grey,
  },
  cancelBtn: {
    color: '#fff',
    background: theme.palette.primary.blue,
    '&:hover': {
      color: '#fff',
      background: '#1976D2! important',
    },
    '&:focus': {
      color: '#fff',
      background: `${theme.palette.primary.blue} !important`,
    }
  },
  confirmBtn: {
    color: '#fff',
    // background: '#de6464',
    background: theme.palette.error.red,
    '&:hover': {
      color: '#fff',
      background: '#D32F2F !important'
    },
    '&:focus': {
      color: '#fff',
      background: `${theme.palette.error.red} !important`
    }
  }
});
